import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import { useSelector } from "react-redux";
import UserBanner from "../user-banner/UserBanner";
import { isNonEmptyArray } from "../../../../common/utils";
import { useApi } from "../../../../common/hooks";
import { LicenceManagementService, PortfolioSearchService } from "../../../../api";
import style from "./UserView.module.css";
import ViewContent from "./components/ViewContent";
import { translate } from "../../../../common/providers";

export default function UserView(user) {
	const { call: getMyPortfolios } = useApi(PortfolioSearchService.getMyPortfolios);
	const { call: getUserCommitmentAccess } = useApi(LicenceManagementService.getUserCommitmentAccess);
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const [selectedPage, setSelectedPage] = useState("");
	const [customPages, setCustomPages] = useState([]);
	const [hasEngagementAccess, setHasEngagementAccess] = useState(false);

	useEffect(() => {
		getMyPortfolios()
			.then((data) => {
				if (isNonEmptyArray(data)) {
					// Add static "Suivi des engagements" tab after "Contrats"
					const enhancedData = [...data];
					const contratsIndex = enhancedData.findIndex((page) => page.name === "Contrats");
					if (contratsIndex !== -1) {
						enhancedData.splice(contratsIndex + 1, 0, {
							id: "suiviengagements",
							name: "SuiviEngagements",
						});
					}
					setCustomPages(enhancedData);
					if (enhancedData?.length > 0) {
						setSelectedPage(enhancedData[0]);
					}
				}
			})
			.catch(console.error);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Fetch commitment access when user is selected
	useEffect(() => {
		if (licenceManagementStore?.selectedUser?.id) {
			getUserCommitmentAccess({ userId: licenceManagementStore.selectedUser.id })
				.then((data) => {
					setHasEngagementAccess(data?.value || false);
				})
				.catch(console.error);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [licenceManagementStore?.selectedUser?.id]);
	const handleChange = (event, newValue) => {
		setSelectedPage(newValue);
	};
	return (
		<Grid className={style.contentViewTab}>
			<UserBanner user={user} />
			<Grid id="view_">
				{customPages && customPages.length > 0 && (
					<TabContext value={selectedPage}>
						<TabList onChange={handleChange}>
							{customPages?.map((page) => (
								<Tab
									label={translate(`common:portfolio-tab-navigation.${page?.name.toLowerCase()}`)}
									sx={{ textTransform: "none" }}
									value={page}
								/>
							))}
						</TabList>{" "}
						{customPages?.map(
							(page) =>
								page.toString() === selectedPage.toString() && (
									<TabPanel key={page.id} className={style.containerViewTab} value={page}>
										<ViewContent
											hasEngagementAccess={hasEngagementAccess}
											page={page}
											setHasEngagementAccess={setHasEngagementAccess}
										/>
									</TabPanel>
								)
						)}
					</TabContext>
				)}
			</Grid>
		</Grid>
	);
}
